import React, { useState } from 'react';
import { Button } from 'reactstrap';
import AddEditFieldModal from '../../Fields/Add_Edit/AddEditFieldModal';

export const AddFieldButton = ({ dataField, isEdit, resultHandler }) => {
	const [fieldModal, setFieldModal] = useState(false);
	return (
		<>
			<Button
				className='btn btn-label btn-primary'
				onClick={() => setFieldModal(!fieldModal)}
			>
				<i className={`${Icons.plus} label-icon`}></i> Agregar Campo
			</Button>
			<AddEditFieldModal
				dataField={dataField}
				isEdit={isEdit}
				isOpen={fieldModal}
				handleToggleModal={() => setFieldModal(!fieldModal)}
				resultHandler={resultHandler}
			/>
		</>
	);
};
